import qz from 'qz-tray';
import ICompany from '~/interfaces/ICompany';
import IOrder from '~/interfaces/IOrder';
import getPrintBluetoothV1 from '~/utils/getPrintBluetooth';
import { formatAddress } from './formatAddress';
import getCurrencyFormatted from './getCurrencyFormatted';
import getEncondingPrinter from './getEncodingPrinter';
import getPrintBluetooth from './getPrintBluetooth-v2';
import { getPrintEscPos } from './getPrintEscPos';
import getPrintHTML from './getPrintHTML';

type HandlePrintProps = {
  order: IOrder;
  company: ICompany;
  parcial?: boolean;
  cozinha?: boolean;
};

export async function handlePrint({
  order,
  company,
  parcial,
  cozinha,
}: HandlePrintProps): Promise<void> {
  const ua = navigator.userAgent.toLowerCase();
  const isAndroid = ua.indexOf('android') > -1;

  const savedPrinters = JSON.parse(
    localStorage.getItem('@tempedido:printers') || '{}',
  );

  const {
    print_description,
    print_payment_value,
    print_products,
    percentage_optional,
  } = company;

  const parseOrder = {
    ...order,
    additionValue_formatted:
      order?.additionValue && order?.additionValue > 0
        ? getCurrencyFormatted(order?.additionValue)
        : '',
  };

  console.log(
    'aqui',
    getPrintBluetooth(parseOrder, {
      print_description,
      print_payment_value: print_payment_value === '1',
      percentage_optional: !!order.table?.uid && percentage_optional === '1',
      waiter_name: parseOrder.waiter_name,
      print_products: print_products === '1',
      parcial,
    }),
  );

  if ((window as any).electronAPI && (window as any).electronAPI.printText) {
    if (Object.keys(savedPrinters).length > 0) {
      let printType = '';
      if (parcial) printType = 'parcial';
      if (cozinha) printType = 'cozinha';

      (window as any).electronAPI
        .printText({
          ...parseOrder,
          p_address: formatAddress(parseOrder.address),
          p_print_description: print_description,
          p_print_payment_value: print_payment_value === '1',
          p_percentage_optional:
            !!order.table?.uid && percentage_optional === '1',
          p_waiter_name: parseOrder.waiter_name,
          printType,
        })
        .then((response: any) => console.log(response));

      return;
    }
  }

  if (isAndroid) {
    const orderTxt =
      company.printer_model === '1'
        ? getPrintBluetoothV1(parseOrder, {
            print_description,
            print_payment_value: print_payment_value === '1',
            waiter_name: parseOrder.waiter_name,
          })
        : getPrintBluetooth(parseOrder, {
            print_description,
            print_payment_value: print_payment_value === '1',
            percentage_optional:
              !!order.table?.uid && percentage_optional === '1',
            waiter_name: parseOrder.waiter_name,
            print_products: print_products === '1',
            parcial,
          });

    const base64 = getEncondingPrinter({
      orderTxt,
      model_printer: company.printer_model,
    });

    const link = document.createElement('a');
    link.setAttribute('styles', 'display: none');
    link.setAttribute('target', '_blank');
    link.href = base64;
    document.body.appendChild(link);
    link.click();
    return;
  }

  if (company.escpos_printer) {
    const command = getPrintEscPos(parseOrder, {
      print_description,
      print_payment_value: print_payment_value === '1',
      print_products: print_products === '1',
    });

    try {
      await qz.websocket.connect();
    } catch (error) {
      console.log(error);
    } finally {
      const config = qz.configs.create(company.escpos_printer);
      await qz.print(config, [command]);
    }

    return;
  }

  const content = getPrintHTML(parseOrder, {
    print_description,
    print_payment_value: print_payment_value === '1',
    print_products: print_products === '1',
    percentage_optional: !!order?.table?.uid && percentage_optional === '1',
    waiter_name: parseOrder.waiter_name,
  });

  const win = window.open('about:blank');

  if (win) {
    win.document.write(content);
    win.window.print();
    win.window.close();
  }
}
